import PropTypes from 'prop-types';
import React from 'react';
import './Price.scss';

const formatMoney = price => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(price);
};

const Price = ({ price, showZero, initialPrice = null }) => {
  return (
    <span className="Price">
      {price == 0 ? `${showZero ? formatMoney(0) : ''}` : formatMoney(price)}
      {initialPrice != null && initialPrice != price && (
        <span className="Price__initial">
          {initialPrice == 0
            ? `${showZero ? formatMoney(0) : ''}`
            : formatMoney(initialPrice)}
        </span>
      )}
    </span>
  );
};

Price.propTypes = {
  price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  showZero: PropTypes.bool,
  initialPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default Price;
